.rows {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-lg);
}

.row {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-xs);
}

.label {
  font-size: var(--mantine-font-size-sm);
  font-weight: 600;
  color: var(--adl-text-secondary);
}

.body {
  font-size: var(--mantine-font-size-md);
  color: var(--adl-text-primary);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
